import Button from "@components/atoms/button";
import { useRouter } from "next/router";
import { translate } from "@locales";
import Link from "next/link";
import classNames from "classnames";
import useAmplitude from "@models/interactions/use-amplitude";
import { useAtomValue } from "jotai";
import { UserAtom } from "@models/state";

interface Props {
  index?: string;
  search?: string;
  query?: string;
  isLoading?: boolean;
  setIndex: (data: string) => void;
  setIsLoading: (data: boolean) => void;
}

export function useNavSearch(props: Props) {
  const { operations } = useAmplitude();
  const user = useAtomValue(UserAtom);
  const router = useRouter()

  function handleClick(index: string): void {
    if (!props.search?.length) return;
    operations.send(user ? "Clicked Component" : "Unknown User Clicked Component", {
      name: `change-search-tabs`,
      title: `Change Search Tabs`,
      user_id: operations.getUserId,
      unknown_user_id: operations.getUserId,
      path: router.asPath,
      click_at: Date.now()
    })
    //Click events
    props.setIndex(index);
    props.setIsLoading(true);
    router.push(`/search/${props.search}/${index}`);
  }

  return {
    models: {},
    operations: {
      handleClick
    }
  }
}

export default function NavSearch(props: Props) {
  const { models, operations } = useNavSearch(props);

  return (
    <div className="flex h-20 w-full items-center justify-center gap-0 py-[25x] border-b border-memod-grey-primary sm:w-[510px] lg:w-[1140px] lg:gap-[65px]">
      <Button.Pill
        disabled={props.isLoading}
        variant="primary"
        className={classNames(
          "!px-4 !py-2 h-auto sm:!py-2.5 sm:!px-6",
          { "!bg-transparent text-white hover:!bg-memod-green-base": props.index !== "memos" }
        )}
        onClick={() => operations.handleClick("memos")}
      >
        {translate("base.Memos")}
      </Button.Pill>
      <Button.Pill
        disabled={props.isLoading}
        variant="primary"
        className={classNames(
          "!px-4 !py-2 h-auto sm:!py-2.5 sm:!px-6",
          { "!bg-transparent text-white hover:!bg-memod-green-base": props.index !== "users" }
        )}
        onClick={() => operations.handleClick("users")}
      >
        {translate("base.creators")}
      </Button.Pill>
      <Button.Pill
        disabled={props.isLoading}
        variant="primary"
        className={classNames(
          "!px-4 !py-2 h-auto sm:!py-2.5 sm:!px-6",
          { "!bg-transparent text-white hover:!bg-memod-green-base": props.index !== "topics" }
        )}
        onClick={() => operations.handleClick("topics")}
      >
        {translate("base.topics")}
      </Button.Pill>
      <Button.Pill
        disabled={props.isLoading}
        variant="primary"
        className={classNames(
          "!px-4 !py-2 h-auto sm:!py-2.5 sm:!px-6",
          { "!bg-transparent text-white hover:!bg-memod-green-base": props.index !== "boards" }
        )}
        onClick={() => operations.handleClick("boards")}
      >
        {translate("base.collections")}
      </Button.Pill>
    </div>
  );
}
